export const FormSectionDivider = () => (
  <div className="mt-10 sm:mt-0">
    <div className="hidden sm:block" aria-hidden="true">
      <div className="py-5">
        <div className="border-t border-gray-200" />
      </div>
    </div>
  </div>
);
